import React, { useEffect, useRef, useState } from "react";
import {
  GeneralDetail,
  Edit,
  Contract,
  SalesUSer,
  UserIconB,
  UpArrow,
  DownArrow,
} from "../../../../assets/svg";
import {
  AddPrimaryButton,
  InputWithLabel,
  Tooltip,
} from "../../../../components/micro/input";
import { InfoCircle } from "iconsax-react";
import EditCompanyModal from "../../modal/EditCompanyModal";
import EditPreferredModal from "../../modal/EditCompanyPreferred";
import {
  DeleteRemark,
  DeleteTechnicians,
  createRemark,
  getCompanies,
} from "../../../../redux/companies/slice";
import { useDispatch, useSelector } from "react-redux";
import RippleLoader from "../../../../components/loader/RippleLoader";
import AddEditSales from "../../modal/AddEditSales";
import ConfirmationModel from "../../../../components/common/ConfirmationModel";
import Action from "../../../../components/common/Action";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

const CompanyInformation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const scrollRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPreferredOpen, setIsPreferredOpen] = useState(false);
  const [isSalesOpen, setIsSalesOpen] = useState(false);
  const [remark, setRemark] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [productDelete, setProductDelete] = useState(null);
  const [salesPersonData, setSalesPersonData] = useState(null);
  const storedData = sessionStorage.getItem("companyData");
  const [modalData, setModalData] = useState(null);
  const [technicianDelete, SetTechnicianDelete] = useState(false);
  const [current, setCurrent] = useState(0);
  const [expanded, setExpanded] = useState(false);
  let companyData = location?.state?.company;

  if (!companyData) {
    try {
      const stored = sessionStorage.getItem("companyData");
      companyData = stored ? JSON.parse(stored)?.company : null;
    } catch (err) {
      console.error("Failed to parse companyData from sessionStorage:", err);
    }
  }

  const closeModal = () => {
    setIsModalOpen(false);
    setIsPreferredOpen(false);
    setIsSalesOpen(false);
  };

  const handleCloseSalesModal = () => {
    setSalesPersonData([]);
    setIsSalesOpen(false);
  };

  const handleEditSales = (salesPerson) => {
    if (!salesPerson || salesPerson.length === 0) return;
    setSalesPersonData(salesPerson);
    setIsSalesOpen(true);
  };

  const handleChange = (e) => {
    setRemark(e.target.value);
  };

  const handleEditClick = (remark) => {
    setRemark(remark.remark);
    setSelectedRemark(remark);
    setIsEditing(true);
  };

  const deleteStaffId = () => {
    setIsLoading(true);
    dispatch(DeleteRemark(productDelete))
      .then((res) => {
        if (res.type === "DeleteRemark/fulfilled") {
          dispatch(getCompanies({ id: companyData?.id }));
        }
        setIsLoading(false);
        setConfirmDelete(false);
      })
      .catch((error) => {
        console.error("Error deleting remark:", error);
        setIsLoading(false);
      });
  };

  const deleteTechnician = () => {
    setIsLoading(true);
    dispatch(DeleteTechnicians(productDelete))
      .then((res) => {
        if (res.type === "DeleteTechnicians/fulfilled") {
          dispatch(getCompanies({ id: companyData?.id }));
        }
        setIsLoading(false);
        SetTechnicianDelete(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  // Selector
  const { companiesListData, loading } = useSelector((store) => ({
    companiesListData: store?.companiesData?.getCompaniesStatus?.data?.data,
    loading: store?.companiesData?.loading,
  }));

  useEffect(() => {
    dispatch(getCompanies({ id: companyData?.id }));
  }, [companyData?.id]);

  const getCompanyId = companiesListData?.data?.find(
    (company) => company.id === companyData?.id
  );

  const company = companiesListData || getCompanyId;

  const handleFormSubmit = async () => {
    const payload = {
      company_id: companyData?.id,
      remark: remark,
      ...(isEditing && { id: selectedRemark?.id }),
    };
    setIsLoading(true);
    try {
      await dispatch(createRemark(payload));
      setRemark("");
      setIsEditing(false);
      setSelectedRemark(null);
      setIsLoading(false);
      setShowConfirmationModal(false);
      closeModal();
      dispatch(getCompanies({ id: companyData?.id }));
    } catch (error) {
      setIsLoading(false);
      console.error("Error submitting form: ", error);
    }
  };

  const handleNext = () => {
    if (current < company?.serviceContract?.length - 1) {
      setCurrent(current + 1);
      setExpanded(false);
    }
  };

  const handleBack = () => {
    if (current > 0) {
      setCurrent(current - 1);
      setExpanded(false);
    }
  };

  const contract = company?.serviceContract[current];

  useEffect(() => {
    const container = scrollRef.current;
    const activeDot = container?.children[current];
    if (activeDot) {
      container.scrollTo({
        left:
          activeDot.offsetLeft -
          container.offsetWidth / 2 +
          activeDot.offsetWidth / 2,
        behavior: "smooth",
      });
    }
  }, [current]);

  const expiryDate = contract?.expiry_date
    ? moment(contract?.expiry_date, "Do MMM YYYY")
    : null;

  const totalCount = contract?.total_count;
  const availableCount = contract?.service_contract_used;

  const isExpired =
    expiryDate &&
    moment?.isMoment(expiryDate) &&
    expiryDate?.isBefore(moment(), "day");
  const isCompleted = Number(totalCount) === Number(availableCount);

  const getExpiryStatus = () => {
    if (!expiryDate || !moment(expiryDate).isValid()) {
      return <span>-</span>;
    }

    if (isCompleted) {
      return (
        <span className="text-green-600">
          {moment(expiryDate).format("Do MMM YYYY")} (Completed)
        </span>
      );
    } else if (isExpired) {
      return (
        <span className="text-red-600">
          {moment(expiryDate).format("Do MMM YYYY")} (Expiring)
        </span>
      );
    }

    return <span>{moment(expiryDate).format("Do MMM YYYY")}</span>;
  };

  return (
    <>
      <div className="space-y-5">
        {loading ? (
          <RippleLoader />
        ) : (
          <>
            {/* Information Panels */}
            <div className="grid grid-cols-2 gap-4">
              <div className="grid grid-cols-1 gap-4">
                {/* General Details */}
                <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg h-64">
                  <div className="flex items-center justify-between bg-background_grey py-5 px-6 border-b border-b-Grey">
                    <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey">
                      <GeneralDetail />
                      <span>General Details</span>
                    </h2>
                    <button
                      className="cursor-pointer"
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                    >
                      <Edit />
                    </button>
                  </div>
                  <div className="py-5 px-6 grid grid-cols-2 gap-y-4 ">
                    <div className="space-y-1">
                      <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                        Company Name:
                      </p>
                      <p className="text-sm font-normal text-primaryBlack font-Proxima">
                        {company?.name || companyData?.name || "-"}
                      </p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                        UEN:
                      </p>
                      <p className="text-sm font-normal text-primaryBlack font-Proxima">
                        {company?.uen || companyData?.uen || "-"}
                      </p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                        Mobile Number:
                      </p>
                      <p className="text-sm font-normal text-primaryBlack font-Proxima">
                        {company?.phone || "-"}
                      </p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                        Email:
                      </p>
                      <p className="text-sm font-normal text-primaryBlack font-Proxima">
                        {company?.email || "-"}
                      </p>
                    </div>
                    <div className="col-span-2 space-y-1">
                      <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                        Address:
                      </p>
                      <div className="text-sm font-normal text-primaryBlack font-Proxima">
                        <p className="text-sm font-normal text-primaryBlack font-Proxima">
                          {company?.address || companyData?.address || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Sales Person */}
                <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg h-40 overflow-x-hidden overflow-y-auto">
                  <div className="flex items-center justify-between bg-background_grey py-5 px-6 border-b border-b-Grey h-16">
                    <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey">
                      <SalesUSer />
                      <span>Sales Person</span>
                    </h2>
                    {company?.sales_persons?.length ? (
                      <button
                        className="cursor-pointer"
                        onClick={() =>
                          handleEditSales(company?.sales_persons || [])
                        }
                      >
                        <Edit />
                      </button>
                    ) : (
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setIsSalesOpen(true);
                        }}
                      >
                        <AddPrimaryButton value="Add" />
                      </div>
                    )}
                  </div>
                  {company?.sales_persons?.length ? (
                    <div className="space-y-1 px-6 py-5 h-20">
                      <p className="text-[12px] text-textSecondary font-normal font-Proxima">
                        Person In-Charge
                      </p>
                      <div className="text-sm font-normal text-primaryBlack font-Proxima">
                        {company?.sales_persons?.map((salesPerson, index) => (
                          <p key={salesPerson.id}>
                            {index + 1}. {salesPerson?.user?.full_name}
                          </p>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-center text-center items-center h-20">
                      <p className="text-sm text-textSecondary font-normal font-Proxima">
                        “No Preferred Sales Person" <br />
                        Start adding now!
                      </p>
                    </div>
                  )}
                </div>
                {/* Contract Details */}
                <div className="w-full bg-white shadow rounded-xl overflow-hidden">
                  <div className="flex justify-between items-center border-b border-b-Grey bg-background_grey px-6 py-4">
                    <div className="flex items-center gap-2">
                      <Contract />
                      <h2 className="text-xl text-mgrey font-medium">
                        Contract Details
                      </h2>
                    </div>
                    {isCompleted && (
                      <button
                        className="text-themeBtn border border-themeBtn px-3 py-2 text-sm rounded"
                        onClick={() =>
                          navigate("/create-edit-recurring-service", {
                            state: {
                              mode: "Renew",
                              renewData: contract,
                            },
                          })
                        }
                      >
                        RENEW
                      </button>
                    )}
                  </div>

                  {company?.serviceContract?.length ? (
                    <div>
                      <div className="px-6 py-4 space-y-3">
                        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                          <div>
                            <p className="text-xs text-textSecondary font-Proxima">
                              Contract Status
                            </p>
                            <p className="text-sm text-mgrey font-Proxima">
                              {contract?.contrat_status || "-"}
                            </p>
                          </div>

                          <div>
                            <p className="text-xs text-textSecondary font-Proxima">
                              Expiry date
                            </p>
                            <p className="text-sm text-mgrey font-Proxima">
                              <p>{getExpiryStatus()}</p>
                            </p>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                          <div>
                            <p className="text-xs text-textSecondary font-Proxima">
                              Total Outlets
                            </p>
                            <p className="text-sm text-mgrey font-Proxima">
                              {contract?.total_outlet || "-"}
                            </p>
                          </div>
                          <div>
                            <p className="text-xs text-textSecondary font-Proxima">
                              Total Outlets On Contract
                            </p>
                            <p className="text-sm text-mgrey font-Proxima">
                              {contract?.total_outlet_on_contract || "-"}
                            </p>
                          </div>
                        </div>

                        <div>
                          <p className="text-xs text-textSecondary font-Proxima">
                            Available Count
                          </p>
                          <p className="text-sm text-mgrey font-Proxima">
                            {contract?.service_contract_used}/
                            {contract?.total_count}
                          </p>
                        </div>

                        <div className="border-t border-t-Grey pt-2">
                          <div
                            className="flex justify-between items-center cursor-pointer"
                            onClick={() => setExpanded(!expanded)}
                          >
                            <p className="text-xs text-textSecondary font-Proxima">
                              Outlets on Contract (
                              {contract?.total_outlet_on_contract || "-"})
                            </p>
                            {expanded ? <UpArrow /> : <DownArrow />}
                          </div>

                          {expanded && (
                            <div className="grid grid-cols-2 gap-x-4 gap-y-1 mt-2 text-sm text-mgrey font-Proxima">
                              {contract?.service_outlets?.map((el, idx) => (
                                <div key={idx}>
                                  {idx + 1}. {el?.outlet?.name}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="flex items-center justify-between px-6 py-2">
                        <button
                          className="text-themeBtn text-sm disabled:text-disableGray"
                          onClick={handleBack}
                          disabled={current === 0}
                        >
                          ← BACK
                        </button>

                        <div className="relative flex justify-center">
                          <div
                            ref={scrollRef}
                            className="flex gap-2 max-w-[160px] overflow-x-auto hide-scrollbar px-1"
                            style={{
                              scrollbarWidth: "none",
                              msOverflowStyle: "none",
                            }}
                          >
                            {Array.from({
                              length: company?.serviceContract?.length,
                            }).map((_, index) => (
                              <div
                                key={index}
                                className={`w-2 h-2 rounded-full shrink-0 transition-all duration-300 ${
                                  current === index
                                    ? "bg-themeBtn"
                                    : "bg-disableGray"
                                }`}
                              />
                            ))}
                          </div>
                        </div>

                        <button
                          className="text-themeBtn text-sm disabled:text-disableGray"
                          onClick={handleNext}
                          disabled={
                            current === company?.serviceContract?.length - 1
                          }
                        >
                          NEXT →
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-center text-center items-center h-32">
                      <div>
                        <p className="text-[14px] text-textSecondary font-normal font-Proxima">
                          “Not on <br />
                          Recurring Contract”
                        </p>
                        <button
                          className="text-[14px] text-themeBtn border-b border-b-themeBtn font-normal font-Proxima"
                          onClick={() =>
                            navigate("/create-edit-recurring-service", {
                              state: {
                                mode: "companyRecurring",
                                companyData: company || companyData,
                              },
                            })
                          }
                        >
                          Start Creating Now!
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-4">
                {/* Preferred Technician */}
                <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg h-64 overflow-x-hidden overflow-y-auto">
                  <div className="flex items-center justify-between bg-background_grey py-3 px-6 border-b border-b-borderLine h-16">
                    <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey justify-center text-center">
                      <UserIconB />
                      <span>Preferred Technician</span>
                    </h2>
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        setModalData(null);
                        setIsPreferredOpen(true);
                      }}
                    >
                      <AddPrimaryButton value="Add" />
                    </div>
                  </div>
                  {company?.technicians?.length ? (
                    <div className="px-6 py-4 h-44">
                      <table className="w-full text-left">
                        <tbody>
                          {company?.technicians?.map((tech, index) => (
                            <tr
                              key={index}
                              className="border-b border-textGrey"
                            >
                              <td className="py-4 text-sm font-normal text-mgrey">
                                {index + 1}
                              </td>
                              <td className=" text-sm font-medium text-themeBtn cursor-pointer font-Proxima">
                                {tech?.technician?.full_name}
                              </td>
                              <td className=" text-sm font-medium text-mgrey font-Proxima">
                                {tech?.technician?.type}
                              </td>
                              <td className="py-4 text-sm font-normal text-mgrey font-Proxima">
                                {tech?.role}
                              </td>
                              <td>
                                <Tooltip
                                  label={
                                    <>
                                      <InfoCircle size="16" />
                                    </>
                                  }
                                  tooltipLabel={
                                    <>
                                      <div className="whitespace-nowrap">
                                        {tech?.outlets?.map((el, index) => {
                                          return (
                                            <div className="flex">
                                              <p>{index + 1}. </p>{" "}
                                              <p>{el.name}</p>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </>
                                  }
                                  isLeft={true}
                                />
                              </td>
                              <td>
                                <Action
                                  optionList={
                                    <>
                                      <li
                                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                        onClick={() => {
                                          setModalData({
                                            technician: tech,
                                            mode: "edit",
                                          });
                                          setIsPreferredOpen(true);
                                        }}
                                      >
                                        Edit
                                      </li>
                                      <li
                                        className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                        onClick={() => {
                                          SetTechnicianDelete(true);
                                          setProductDelete(tech?.id);
                                        }}
                                      >
                                        Delete
                                      </li>
                                    </>
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div>
                      <div className="flex justify-center text-center h-44 items-center">
                        <p className="text-[14px] text-textSecondary font-normal font-Proxima">
                          “No Preferred Technician" <br />
                          Start adding now!
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                {/* Remark */}
                <div className="w-full bg-bgWhite shadow drop-shadow-md rounded-lg min-h-52 overflow-x-hidden overflow-y-auto">
                  <div className="flex items-center justify-between bg-background_grey py-5 px-6 border-b border-b-Grey h-16">
                    <h2 className="flex items-center gap-2 text-xl font-medium text-mgrey">
                      <SalesUSer />
                      <span>Remark</span>
                    </h2>
                  </div>
                  {company?.company_remarks?.length > 0 ? (
                    <>
                      <div className="space-y-1 px-6 py-5 max-h-48 overflow-x-hidden overflow-y-auto">
                        <table className="min-w-full table-auto">
                          <thead className="text-sm text-gray-700 bg-bgLightTheme font-semibold text-start">
                            <tr className="bg-gray-100">
                              <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
                                No.
                              </th>
                              <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
                                Remark
                              </th>
                              <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
                                Date
                              </th>
                              <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {company?.company_remarks?.map((remark, index) => (
                              <tr
                                key={remark.id}
                                className="font-Proxima shadow-sm text-mgrey hover:bg-bgLightTheme"
                              >
                                <td className="px-4 py-2 text-sm text-textGrey">
                                  {index + 1}
                                </td>
                                <td className="px-4 py-2 text-sm text-textGrey truncate max-w-20">
                                  {remark.remark}
                                </td>
                                <td className="px-4 py-2 text-sm text-textGrey">
                                  {new Date(remark.created_at).toLocaleString()}
                                </td>
                                <td className="px-4 py-2 text-sm text-textGrey">
                                  <Action
                                    optionList={
                                      <>
                                        <li
                                          className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                          onClick={() =>
                                            handleEditClick(remark)
                                          }
                                        >
                                          Edit
                                        </li>
                                        <li
                                          className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                                          onClick={() => {
                                            setConfirmDelete(true);
                                            setProductDelete(remark?.id);
                                          }}
                                        >
                                          Delete
                                        </li>
                                      </>
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="space-y-1 px-6 py-5 flex flex-col justify-between">
                        <InputWithLabel
                          idFromName="addRemark"
                          label="Add Remark"
                          type="textarea"
                          className="text-textGrey border max-h-64"
                          value={remark}
                          rows={4}
                          onChange={handleChange}
                          style={{ maxHeight: "70px" }}
                        />
                        <div className="flex justify-end mt-4">
                          <button
                            onClick={(values) => {
                              setFormValues(values);
                              setShowConfirmationModal(true);
                            }}
                            className={`w-full rounded-sm p-1 font-normal font-Proxima cursor-pointer ${
                              remark.length > 0
                                ? "bg-themeBtn text-white"
                                : "bg-borderLine text-textSecondary"
                            }`}
                            disabled={remark.length === 0}
                          >
                            {isEditing ? "EDIT" : "ADD"}
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="space-y-1 px-6 py-4 flex min-h-36 flex-col justify-between">
                      <InputWithLabel
                        idFromName="addRemark"
                        label="Add Remark"
                        type="textarea"
                        className="text-textGrey border max-h-64"
                        value={remark}
                        rows={4}
                        onChange={handleChange}
                        style={{ maxHeight: "256px" }}
                      />
                      <div className="flex justify-end mt-2">
                        <button
                          onClick={(values) => {
                            setFormValues(values);
                            setShowConfirmationModal(true);
                          }}
                          className={`w-full rounded-sm p-1 font-normal font-Proxima cursor-pointer ${
                            remark.length > 0
                              ? "bg-themeBtn text-white"
                              : "bg-borderLine text-textSecondary"
                          }`}
                          disabled={remark.length === 0}
                        >
                          ADD
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {isModalOpen && (
        <div>
          <EditCompanyModal
            onClose={closeModal}
            companyData={companyData}
            company={company}
          />
        </div>
      )}
      {isPreferredOpen && (
        <div>
          <EditPreferredModal
            onClose={closeModal}
            companyId={companyData?.id}
            company={company}
            modalData={modalData}
          />
        </div>
      )}
      {isSalesOpen && (
        <div>
          <AddEditSales
            onClose={handleCloseSalesModal}
            companyId={companyData?.id}
            company={company?.sales_persons}
            salesPersonData={salesPersonData}
          />
        </div>
      )}
      {showConfirmationModal && (
        <div>
          <ConfirmationModel
            confirmText={isEditing ? "Edit" : "Create"}
            onClose={() => setShowConfirmationModal(false)}
            onConfirm={() => handleFormSubmit(formValues)}
            isLoading={isLoading}
          />
        </div>
      )}
      {confirmDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              setConfirmDelete(false);
            }}
            onConfirm={deleteStaffId}
            isLoading={isLoading}
          />
        </div>
      )}

      {technicianDelete && (
        <div>
          <ConfirmationModel
            confirmText={"Delete"}
            onClose={() => {
              SetTechnicianDelete(false);
            }}
            onConfirm={deleteTechnician}
            isLoading={isLoading}
          />
        </div>
      )}
    </>
  );
};

export default CompanyInformation;
